export default __webpack_public_path__ + "3078932cc2f3c414b1a4ee36e2595d80.png";